<script setup>
  import { ref, computed, onMounted, watchEffect} from 'vue';
  import { useUserStore } from '@/stores/UserStore';
  import BaseModal from '@/components/base/BaseModal.vue';
  import ModalSectionSelectProfiles from '@/components/ModalSectionSelectProfiles.vue';

  const emits = defineEmits(['close']);
  
  const props = defineProps({
    items: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
  });

  const userStore = useUserStore();

  const selectedProfiles = ref([]);
  const showModal = ref(false);

  const modalTitle = computed(() => props.action === 'copy' ? 'Copy Container' : 'Move Container');
  const buttonText = computed(() => props.action === 'copy' ? 'Copy' : 'Move');
  const availableProfiles = computed(() => userStore.userProfiles.profiles.filter(profile => profile.profile_id !== userStore.currentProfileId));

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  async function handleCompleteActionClick() {
    const items = JSON.parse(JSON.stringify(props.items));

    await userStore.moveCopyItemsToProfiles({
      items: items, 
      profiles: selectedProfiles.value,
      type: props.type,
      action: props.action
    });
    await userStore.getProfiles(true);

    if (props.type === 'spot') {
      await userStore.getSpotDetailSetByProfile()
    }

    const actionLabel = props.action === 'move' ? 'Moved' : 'Copied';
    const profileText = selectedProfiles.value.length === 1 
      ? `${userStore.getProfileById(selectedProfiles.value[0]).name} profile`
      : `${selectedProfiles.value.length} selected profiles.`;

    const toastMessage = !Array.isArray(items) || items.length === 1
      ? `${actionLabel} ${props.type} to ${profileText}.`
      : `${actionLabel} ${items.length} ${props.type}s to ${profileText}`

    if (jwc) {
      jwc.toaster.toast({
        type: 'success',
        content: toastMessage,
      })
    }        

    closeModal();    
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  });  
</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
    height="tall"
  >  
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">{{ modalTitle }}</h2>
    </header>          
    <div class="jwx-modal__body">
      <ModalSectionSelectProfiles v-model="selectedProfiles" :profiles="availableProfiles" />
    </div>
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button 
          type="button" 
          @click.prevent="closeModal"
          class="jwx-button jwx-button--danger"
        >
          Cancel
        </button>
        <button 
          type="button" 
          @click.prevent="handleCompleteActionClick"
          class="jwx-button jwx-button--success"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </BaseModal>
</template>